var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { VersionedTransaction } from "@solana/web3.js";
import { delay } from "./delay";
import { checkOptionSend } from "./check";
import { isVersionedTransaction } from "@solana/wallet-adapter-base";
export function sendSingleTransaction(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var cOptionSend, commitment, connection, retryDelay, skipSimulation, tx, recentBlockhash, hash, keepChecking, check;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cOptionSend = checkOptionSend(Data);
                    commitment = cOptionSend.commitment, connection = cOptionSend.connection, retryDelay = cOptionSend.retryDelay, skipSimulation = cOptionSend.skipSimulation;
                    tx = Data.tx;
                    if (!tx.signers)
                        throw new Error("No signers provided");
                    return [4 /*yield*/, connection.getLatestBlockhash(commitment)];
                case 1:
                    recentBlockhash = _a.sent();
                    tx.tx.message.recentBlockhash = recentBlockhash.blockhash;
                    tx.tx.sign(tx.signers);
                    return [4 /*yield*/, connection.sendTransaction(tx.tx, {
                            skipPreflight: skipSimulation,
                        })];
                case 2:
                    hash = _a.sent();
                    keepChecking = true;
                    _a.label = 3;
                case 3:
                    if (!keepChecking) return [3 /*break*/, 9];
                    return [4 /*yield*/, checkTransaction({
                            connection: connection,
                            hash: hash,
                            blockheight: recentBlockhash.lastValidBlockHeight,
                            commitment: commitment,
                            tx: tx.tx,
                        })];
                case 4:
                    check = _a.sent();
                    if (!(check === true)) return [3 /*break*/, 5];
                    keepChecking = false;
                    console.log("Transaction confirmed: ", hash);
                    return [3 /*break*/, 8];
                case 5:
                    if (!(check === null)) return [3 /*break*/, 7];
                    return [4 /*yield*/, delay(retryDelay)];
                case 6:
                    _a.sent();
                    return [3 /*break*/, 8];
                case 7: throw new Error("Transaction failed");
                case 8: return [3 /*break*/, 3];
                case 9: return [2 /*return*/, hash];
            }
        });
    });
}
export function sendSingleBundleTransaction(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var cOptionSend, commitment, connection, retryDelay, skipSimulation, bt, signer, _a, tx, _b, recentBlockhash, keepChecking, check, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    cOptionSend = checkOptionSend(Data);
                    commitment = cOptionSend.commitment, connection = cOptionSend.connection, retryDelay = cOptionSend.retryDelay, skipSimulation = cOptionSend.skipSimulation;
                    bt = Data.bt, signer = Data.signer;
                    if (!!bt.stx) return [3 /*break*/, 2];
                    if (!signer)
                        throw new Error("No signer provided");
                    bt.stx = bt.tx;
                    if (!isVersionedTransaction(bt.stx))
                        bt.stx = new VersionedTransaction(bt.stx.compileMessage());
                    _a = bt.stx.message;
                    return [4 /*yield*/, connection.getLatestBlockhash()];
                case 1:
                    _a.recentBlockhash = (_c.sent()).blockhash;
                    bt.stx.sign([signer]);
                    return [3 /*break*/, 3];
                case 2:
                    if (!isVersionedTransaction(bt.stx)) {
                        if (bt.stx.signatures.filter(function (sig) { return !!sig.signature; }).length === 0)
                            throw new Error("No signature found");
                    }
                    else {
                        if (bt.stx.signatures.filter(function (sig) { return !!sig; }).length === 0)
                            throw new Error("No signature found");
                    }
                    _c.label = 3;
                case 3:
                    if (!bt.stx)
                        throw new Error("No signed Transaction provided");
                    bt.stx.signatures.forEach(function (sig, i) {
                        if (sig.toLocaleString().length === 0)
                            throw new Error("No signers provided at index " + i);
                    });
                    tx = bt.stx;
                    if (!isVersionedTransaction(tx))
                        tx = new VersionedTransaction(tx.compileMessage());
                    // if
                    _b = bt;
                    return [4 /*yield*/, connection.sendTransaction(tx, {
                            skipPreflight: skipSimulation,
                        })];
                case 4:
                    // if
                    _b.hash = _c.sent();
                    bt.status = "broadcast";
                    return [4 /*yield*/, connection.getLatestBlockhash()];
                case 5:
                    recentBlockhash = _c.sent();
                    keepChecking = true;
                    _c.label = 6;
                case 6:
                    if (!keepChecking) return [3 /*break*/, 15];
                    _c.label = 7;
                case 7:
                    _c.trys.push([7, 13, , 14]);
                    return [4 /*yield*/, checkTransaction({
                            connection: connection,
                            hash: bt.hash,
                            blockheight: recentBlockhash.lastValidBlockHeight,
                            commitment: commitment,
                            tx: tx,
                        })];
                case 8:
                    check = _c.sent();
                    if (!(check === true)) return [3 /*break*/, 9];
                    keepChecking = false;
                    bt.status = "success";
                    console.log(bt.description.split(".")[0], "confirmed: ", bt.hash);
                    return [3 /*break*/, 12];
                case 9:
                    if (!(check === null)) return [3 /*break*/, 11];
                    return [4 /*yield*/, delay(retryDelay)];
                case 10:
                    _c.sent();
                    return [3 /*break*/, 12];
                case 11:
                    bt.status = "failed";
                    throw new Error("Transaction failed");
                case 12: return [3 /*break*/, 14];
                case 13:
                    error_1 = _c.sent();
                    if (String(error_1).includes("Could not find transaction after 151 blocks")) {
                        bt.status = "Timeout";
                    }
                    throw error_1;
                case 14: return [3 /*break*/, 6];
                case 15: return [2 /*return*/, bt];
            }
        });
    });
}
function checkTransaction(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var connection, hash, blockheight, commitment, tx, status, block, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    connection = Data.connection, hash = Data.hash, blockheight = Data.blockheight, commitment = Data.commitment, tx = Data.tx;
                    return [4 /*yield*/, connection.getTransaction(hash, {
                            commitment: commitment,
                            maxSupportedTransactionVersion: 0,
                        })];
                case 1:
                    status = _b.sent();
                    if (!(status === null)) return [3 /*break*/, 7];
                    return [4 /*yield*/, connection.getLatestBlockhash(commitment)];
                case 2:
                    block = _b.sent();
                    if (blockheight + 151 < block.lastValidBlockHeight)
                        throw new Error("Could not find transaction after 151 blocks.");
                    if (!tx) return [3 /*break*/, 6];
                    _b.label = 3;
                case 3:
                    _b.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, connection.sendTransaction(tx)];
                case 4:
                    _b.sent();
                    return [3 /*break*/, 6];
                case 5:
                    e_1 = _b.sent();
                    console.log(e_1);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/, null];
                case 7:
                    if ((_a = status.meta) === null || _a === void 0 ? void 0 : _a.err)
                        throw new Error("Transaction failed: " + JSON.stringify(status.meta.err));
                    return [2 /*return*/, true];
            }
        });
    });
}
